// src/com/auto_rotation_his/AutoRotationHis.js
import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/system';
// import { styled } from '@mui/material/styles';
import {DialogContent, Button, DialogActions, CircularProgress} from '@mui/material';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import DoneIcon from '@mui/icons-material/Done'; // close the dialog.
import BarChartIcon from '@mui/icons-material/BarChart'; // 배차 차종 통계
import DraggableViewer from '../../common/DraggableViewer';
import { AppWord, AppStyle, AppObject } from '../../value/AppConst';
import { useAlertSetter } from '../../api/app-hook';
import { autoRotationHisListRepo } from '../../value/AppModel';
import { ContentHeader, ControlBox, CountLabel, ToolBox } from '../../common/TopViewControl';
import { LIST_AUTO_ROTATION_HIS } from './AutoRotationHisGql';
import { AutoRotationHisDictionary } from './AutoRotationHisDict';
import FlexyTable from '../../common/flexytable/FlexyTable';

/**
 * 배차 차종 통계
 * 상온 자동배차에서 배차 차종 통계 버튼 누르면 팝업되는 화면
 * Using React with MUI5
 * Project: NewTOP for cloud
 * https://www.dbdbtap.com
 */
export default function AutoRotationHis({
    open,
    onClose,
    planDate,
}) {
    const autoRotationHisListData = useReactiveVar(autoRotationHisListRepo);
    const [countToDisplay, setCountToDisplay] = useState(0);
    const addAlert = useAlertSetter();
    const readRef = useRef(false);

    // ##### Call GraphQL to get List #####
    const [getAutoRotationHisList, responseList] = useLazyQuery(LIST_AUTO_ROTATION_HIS, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetList(data, option)},
        onError: (error) => addAlert({title: AutoRotationHisDictionary.errorTitle.Get, message: [error.message]})
    });

    useEffect(() => {
        if(open) {
            if(!readRef.current) {
                getAutoRotationHisList({variables: {planDate: planDate}});
                readRef.current = true;
            }
        }
        else readRef.current = false;
    }, [open, planDate]);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetList = (data, clientOption) => {
        if(data.autoRotationHisList) {
            // autoRotationHisListRepo({when:new Date().getTime()/1000, records:data.autoRotationHisList});
            const sum = {
                dcName: '합계',
                planDate: planDate,
                vehTypeName: '',
                usingCarCnt: 0,
                vehCnt: 0,
                total: 0,
                nextDayVehCnt: 0,
                rotationRate: 0,
                early5: 0,
                time06: 0,
                time07: 0,
                time08: 0,
                time09: 0,
                time10: 0,
                time11: 0,
                time12: 0,
                time13: 0,
                time14: 0,
                time15: 0,
                time16: 0,
                time17: 0,
                time18: 0,
                time19: 0,
                time20: 0,
                time21: 0,
                time22: 0,
            };
            let rotateRateSum = 0;
            const list = [];

            data.autoRotationHisList.forEach((item) => {
                // 0~5시까지의 차량 수를 합산 => early5
                item.total = item.vehCnt + item.nextDayVehCnt;
                item.early5 = item.time00 + item.time01 + item.time02 + item.time03 + item.time04 + item.time05;

                sum.usingCarCnt += item.usingCarCnt;
                sum.vehCnt += item.vehCnt;
                sum.nextDayVehCnt += item.nextDayVehCnt;
                rotateRateSum += item.rotationRate;
                sum.total += item.total;

                sum.early5 += item.early5;
                sum.time06 += item.time06;
                sum.time07 += item.time07;
                sum.time08 += item.time08;
                sum.time09 += item.time09;
                sum.time10 += item.time10;
                sum.time11 += item.time11;
                sum.time12 += item.time12;
                sum.time13 += item.time13;
                sum.time14 += item.time14;
                sum.time15 += item.time15;
                sum.time16 += item.time16;
                sum.time17 += item.time17;
                sum.time18 += item.time18;
                sum.time19 += item.time19;
                sum.time20 += item.time20;
                sum.time21 += item.time21;
                sum.time22 += item.time22;
                sum.time23 += item.time23;
                sum.time24 += item.time24;

                list.push(item);
            });

            if(data.autoRotationHisList.length > 0) {
                sum.rotationRate = Math.round(rotateRateSum * 10 / data.autoRotationHisList.length) / 10;
            }
            list.push(sum);
            autoRotationHisListRepo({when:new Date().getTime()/1000, records:list});
        }
    };

    const loadingAny = responseList.loading;

    return(
        <DraggableViewer
            open={open}
            onClose={onClose}
            title="배차 차종 통계"
            fullScreen={true}
            startIcon={<BarChartIcon fontSize={AppWord.LARGE} />}
        >
            <DialogContent style={{position: 'relative', minHeight:'50vh', minWidth:600}}>
                <Box style={{
                    position:'absolute', left:5, top:0, right:5, bottom:3,
                    display:'flex', flexDirection: 'column'}}
                >
                    <ContentHeader>
                        <ControlBox>
                            테이블 헤더의 맨 앞의 아이콘을 클릭하여 엑셀 파일로 저정할 수 있습니다.
                        </ControlBox>
                        <ToolBox>
                            {
                                loadingAny ?
                                <CircularProgress size={20} /> :
                                <CountLabel count={countToDisplay} />
                            }
                        </ToolBox>
                    </ContentHeader>
                    <FlexyTable
                        name={AutoRotationHisDictionary.tableProps.tableId}
                        tableProps={AutoRotationHisDictionary.tableProps}
                        records={autoRotationHisListData.records}
                        onChangeCountToDisplay={setCountToDisplay}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    color={AppStyle.mui.primary}
                    variant={AppStyle.mui.contained}
                    startIcon={<DoneIcon />}
                    disabled={loadingAny}
                >
                    닫기
                </Button>
            </DialogActions>
        </DraggableViewer>
    );
}